import { displayDate, displayTime, VALID_DATE_FORMATS } from '@adsk/alloy-react-datetime';
export default function getTooltipDate(date, T) {
  return T.translate('DATE_AT_TIME', {
    date: displayDate(date, {
      utc: false
    }),
    time: displayTime(date, {
      format: VALID_DATE_FORMATS.NUMERIC,
      utc: false
    })
  });
}
//# sourceMappingURL=getTooltipDate.js.map